function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Text } from '@travel-frontend/core';
import { IconCheckCircleOutline } from '@travel-frontend/icons';
import { List, ListItem } from '../../../../../../../../../primitives/index.js';
const formatDescription = ({
  name,
  type,
  value
}) => {
  if (!name) {
    return null;
  }
  if (type === 'bool' || !value) {
    return name;
  }
  return `${name}: ${value}`;
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1089mxj",
  styles: "white-space:pre-wrap"
} : {
  name: "mj7czm-css",
  styles: "white-space:pre-wrap;label:css;/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRvb2x0aXBDb250ZW50LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtCbUwiLCJmaWxlIjoiVG9vbHRpcENvbnRlbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgVGV4dCB9IGZyb20gJ0B0cmF2ZWwtZnJvbnRlbmQvY29yZSc7XG5pbXBvcnQgeyBJY29uQ2hlY2tDaXJjbGVPdXRsaW5lIH0gZnJvbSAnQHRyYXZlbC1mcm9udGVuZC9pY29ucyc7XG5pbXBvcnQgeyBMaXN0LCBMaXN0SXRlbSB9IGZyb20gJy4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uL3ByaW1pdGl2ZXMvaW5kZXguanMnO1xuY29uc3QgZm9ybWF0RGVzY3JpcHRpb24gPSAoeyBuYW1lLCB0eXBlLCB2YWx1ZSwgfSkgPT4ge1xuICAgIGlmICghbmFtZSkge1xuICAgICAgICByZXR1cm4gbnVsbDtcbiAgICB9XG4gICAgaWYgKHR5cGUgPT09ICdib29sJyB8fCAhdmFsdWUpIHtcbiAgICAgICAgcmV0dXJuIG5hbWU7XG4gICAgfVxuICAgIHJldHVybiBgJHtuYW1lfTogJHt2YWx1ZX1gO1xufTtcbmV4cG9ydCBjb25zdCBUb29sdGlwQ29udGVudCA9ICh7IGRhdGEgfSkgPT4gKF9qc3goTGlzdCwgeyB3aXRoSWNvbnM6IHRydWUsIGNoaWxkcmVuOiBkYXRhXG4gICAgICAgIC5maWx0ZXIoKHsgbmFtZSB9LCBpbmRleCkgPT4gZGF0YS5maW5kSW5kZXgoKHsgbmFtZTogbmFtZTIgfSkgPT4gbmFtZSA9PT0gbmFtZTIpID09PSBpbmRleClcbiAgICAgICAgLm1hcCgodmFsdWUsIGluZGV4KSA9PiB7XG4gICAgICAgIGNvbnN0IGxhYmVsID0gZm9ybWF0RGVzY3JpcHRpb24odmFsdWUpO1xuICAgICAgICByZXR1cm4gbGFiZWwgPyAoX2pzeChMaXN0SXRlbSwgeyBpY29uOiBfanN4KEljb25DaGVja0NpcmNsZU91dGxpbmUsIHt9KSwgc2l6ZTogXCJzbWFsbFwiLCBsYWJlbDogX2pzeChUZXh0LCB7IHByZXNldDogXCJsYWJlbFhTbWFsbFwiLCB0cmFuc2Zvcm06IFwiY2FwaXRhbGl6ZS1maXJzdFwiLCBjc3M6IGNzcyBgXG4gICAgICAgICAgICAgICAgICB3aGl0ZS1zcGFjZTogcHJlLXdyYXA7XG4gICAgICAgICAgICAgICAgYCwgY2hpbGRyZW46IGZvcm1hdERlc2NyaXB0aW9uKHZhbHVlKSB9KSB9LCBpbmRleCkpIDogbnVsbDtcbiAgICB9KSB9KSk7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1Ub29sdGlwQ29udGVudC5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const TooltipContent = ({
  data
}) => _jsx(List, {
  withIcons: true,
  children: data.filter(({
    name
  }, index) => data.findIndex(({
    name: name2
  }) => name === name2) === index).map((value, index) => {
    const label = formatDescription(value);
    return label ? _jsx(ListItem, {
      icon: _jsx(IconCheckCircleOutline, {}),
      size: "small",
      label: _jsx(Text, {
        preset: "labelXSmall",
        transform: "capitalize-first",
        css: _ref,
        children: formatDescription(value)
      })
    }, index) : null;
  })
});